import { downgradeComponent, downgradeInjectable } from "@angular/upgrade/static";
import { FleetNavigationModule } from "@app/main/modules/fleet/fleet.navigation";
import { SensorDataService } from "@app/main/modules/maintenance/_components/sensorData/sensor-data.service";
import { RouteConfigHelperProvider } from "@app/services/routeConfigHelper.provider";
import { AccountFeatures } from "@enums/account/AccountFeature";
import { AuthorizationService } from "@services/authorization.service";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { EditOdometerController } from "./components/editOdometer.controller";
import { VehicleTimelineComponent } from "./components/vehicleTimeline.component";
import { VideoRestrictionComponent } from "./components/videoRestriction.component";
import { DriverTachoSummaryComponent } from "./driverTachoSummary.component";
import { JourneyGraphComponent } from "./journeys/journeyGraph.component";
import { LiveMapController } from "./livemap.controller";
import { NearestGeofencesComponent } from "./nearest/nearestGeofences.component";
import { NearestVehiclesComponent } from "./nearest/nearestVehicles.component";
import { PlotInfoTableComponent } from "./plotInfoTable.component";
import { VehicleHistoryComponent } from "./sideNav/vehicleHistory.component";
import { StreetViewDirective } from "./streetview.directive";
import { TemperatureRowComponent } from "./temperature-row.component";
import { VehicleDriversComponent } from "./vehicleDrivers.component";
import { VehicleHistoryGanttChartComponent } from "./vehicleHistoryGanttChart.component";
import { VehicleSummaryStatisticsComponent } from "./vehicleSummaryStatistics.component";
import { GForceGaugeComponent } from "./video/gForceGauge.component";

export class Config {

    static $inject = ["$stateProvider", "isMobile", "routeConfigHelperProvider"];

    constructor($stateProvider: StateProvider, isMobile: boolean, routeConfigHelperProvider: RouteConfigHelperProvider) {

        let template = require("./livemap.html");
        let controller = "LiveMapController as $ctrl";

        if (isMobile) {
            template = require("../mobile/vehiclemap.html");
            //controller = "vehicleMapController as $ctrl";
            controller = "LiveMapController as $ctrl";
        }

        $stateProvider.state(FleetNavigationModule.Vehicles, {
            url: "/vehicles/:vehicle/:panel/:date",
            views: {
                "content@app": {
                    template: template,
                    controller: controller
                }
            },
            params: {
                vehicle: { squash: true, value: null, dynamic: true },
                panel: { squash: true, value: null, dynamic: true },
                date: { squash: true, value: null, dynamic: true },
                translationKey: "Common.Vehicles"
            },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([], [
                    AccountFeatures.TrackingDevice
                ])]
            }
        });

        routeConfigHelperProvider.createDetailStateWithBoundParams({
            stateName: `${FleetNavigationModule.Vehicles}.view`,
            bindingName: "vehicleId",
            component: "vehicleVideoCard",
            queryParamsNames: ["tab", "requestVideoTime"],
            breadcrumbNameResolverKey: "vehicleVideoNameKey"
        });
    }
}

angular
    .module("app.components.livemap",
        [
            "ui.router",
            "ngMaterial",
            "ngAnimate",
            "highcharts-ng",
            "app.map.directives"
        ])
    .config(Config)

    .component("gforceGauge", new GForceGaugeComponent())
    .component("driverTachoSummary", new DriverTachoSummaryComponent())
    .component("journeyGraph", new JourneyGraphComponent())
    .component("plotInfoTable", new PlotInfoTableComponent())
    .component("vehicleSummaryStatistics", new VehicleSummaryStatisticsComponent())
    .component("vehicleDrivers", new VehicleDriversComponent())
    .component("nearestGeofences", new NearestGeofencesComponent())
    .component("nearestVehicles", new NearestVehiclesComponent())
    .component("vehicleHistory", new VehicleHistoryComponent())
    .component("vehicleHistoryGanttChart", new VehicleHistoryGanttChartComponent())
    .component("vehicleTimeline", new VehicleTimelineComponent())
    .controller("editOdometerController", EditOdometerController)

    .controller("LiveMapController", LiveMapController)

    .directive("videoRestriction", downgradeComponent({ component: VideoRestrictionComponent }))
    .directive("temperatureRow", downgradeComponent({ component: TemperatureRowComponent }))
    .directive("streetView", StreetViewDirective.factory())
    .service("sensorDataService", downgradeInjectable(SensorDataService))
